import React, { SVGProps } from "react";

export default function SupLockOpen(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.6001 13.2C11.6001 13.9455 11.0902 14.572 10.4001 14.7496V16.4H9.6001V14.7496C8.91001 14.572 8.4001 13.9455 8.4001 13.2C8.4001 12.3163 9.11644 11.6 10.0001 11.6C10.8838 11.6 11.6001 12.3163 11.6001 13.2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 2C12.6511 2 14.8001 3.14903 14.8001 5.8H14.0001C14.0001 3.59086 12.2092 2.8 10.0001 2.8C7.79096 2.8 6.0001 4.59086 6.0001 6.8V8.50081C6.25579 8.435 6.52386 8.4 6.8001 8.4H16.4001V14.8C16.4001 16.5673 14.9674 18 13.2001 18H6.8001C5.03279 18 3.6001 16.5673 3.6001 14.8V11.6C3.6001 10.4155 4.24362 9.3814 5.2001 8.8281V6.8C5.2001 4.14903 7.34913 2 10.0001 2ZM15.6001 9.2H6.8001C5.47461 9.2 4.4001 10.2745 4.4001 11.6V14.8C4.4001 16.1255 5.47461 17.2 6.8001 17.2H13.2001C14.5256 17.2 15.6001 16.1255 15.6001 14.8V9.2Z"
        fill="currentColor"
      />
    </svg>
  );
}
